var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg43Covered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84631",
    "data-name": "Group 84631",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.17,
    height: 126.992,
    viewBox: "0 0 99.17 126.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24664",
    "data-name": "Rectangle 24664",
    width: 99.17,
    height: 126.992,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84630",
    "data-name": "Group 84630",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240046",
    "data-name": "Path 240046",
    d: "M49.1,126.992a.662.662,0,0,1-.621-.438c-2.57-7.187-5.231-9.052-10.534-12.768-1.625-1.141-3.466-2.431-5.631-4.094-.635-.488-1.318-.989-2.036-1.515-5.173-3.795-12.256-8.989-18.3-21.409C4.8,72.016.884,51,0,22.523a.661.661,0,0,1,.5-.66C14.41,18.305,33.987,11.65,48.233.146A.661.661,0,0,1,49.041.13C64.636,11.738,87.719,18.953,96.919,21.518a.659.659,0,0,1,.482.686c-.056.725-.13,1.86-.213,3.158-.231,3.557-.517,7.984-.762,9.209a.66.66,0,1,1-1.294-.259c.227-1.139.523-5.7.737-9.035.067-1.017.125-1.934.174-2.635-9.512-2.679-31.908-9.8-47.38-21.15C34.444,12.81,15.213,19.421,1.336,23.01c2.072,63.819,19.374,76.51,29.724,84.1.729.533,1.417,1.04,2.061,1.535,2.142,1.644,3.971,2.927,5.585,4.057,5.083,3.564,7.84,5.5,10.357,11.67,1.8-4.182,6.68-9.447,14.541-15.69,3.834-3.043,7.936-5.939,11.555-8.493,1.9-1.336,3.686-2.6,5.164-3.695a.66.66,0,0,1,.785,1.061c-1.491,1.1-3.286,2.371-5.187,3.712-3.607,2.543-7.692,5.427-11.5,8.449-8.8,6.988-13.738,12.627-14.676,16.76a.661.661,0,0,1-.6.512l-.04,0",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240047",
    "data-name": "Path 240047",
    d: "M45.063,108.031a.221.221,0,0,1-.181-.1c-1.32-1.9-5.641-5.659-12.84-11.182C22.454,89.4,16.056,80.28,11.9,68.065,8.239,57.279,6.185,44.03,5.032,23.764a.222.222,0,0,1,.165-.227C22.671,19.061,35.528,13.307,44.507,5.95a.222.222,0,0,1,.275-.005c9.072,7.044,25.107,11.881,34.687,14.771,2.112.637,3.939,1.188,5.256,1.635a.218.218,0,0,1,.148.232l-.055.486c-.127,1.1-.315,2.772-.315,3.195a.22.22,0,0,1-.44,0c0-.449.19-2.132.317-3.244l.035-.31c-1.3-.433-3.052-.963-5.073-1.574-9.561-2.883-25.531-7.7-34.691-14.736-8.993,7.322-21.81,13.055-39.168,17.519,2.012,35.2,6.9,57.194,26.826,72.486,6.923,5.31,11.205,9.014,12.742,11.018C46.864,104.81,55.226,97.07,61.577,92.9a.22.22,0,0,1,.3.063.223.223,0,0,1-.063.3c-6.549,4.3-15.236,12.388-16.565,14.65a.224.224,0,0,1-.181.109Z",
    transform: "translate(3.825 4.484)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240048",
    "data-name": "Path 240048",
    d: "M31.018,48.061V35.677a.792.792,0,0,0-.792-.792H28.418a.793.793,0,0,0-.792.792l0,12.384a.792.792,0,0,0,.79.792h1.811a.792.792,0,0,0,.792-.792",
    transform: "translate(20.998 26.518)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240049",
    "data-name": "Path 240049",
    d: "M31.54,35.362H29.551V47.44H31.54a.43.43,0,0,0,.428-.431V35.791a.429.429,0,0,0-.428-.429",
    transform: "translate(22.463 26.88)",
    fill: "#e5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240050",
    "data-name": "Path 240050",
    d: "M51.255,37.271l-8.711-.007a1.489,1.489,0,0,0,0-2.978H40.688a6.84,6.84,0,0,0-3.9,1.22c-1,.577-1.8,1.681-4.172,1.781l-1.693.023v9.735h3.295a8.968,8.968,0,0,1,2.95.634,5.7,5.7,0,0,0,1.76.278h6.828a1.337,1.337,0,1,0,0-2.674,1.337,1.337,0,1,0,0-2.674,1.336,1.336,0,1,0,0-2.672h5.5a1.333,1.333,0,0,0,0-2.667Z",
    transform: "translate(23.507 26.062)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240051",
    "data-name": "Path 240051",
    d: "M47.958,30.878a1.764,1.764,0,0,1,.273.021v-.2a.225.225,0,0,1,.229-.224.188.188,0,0,1,.044.005,4.605,4.605,0,0,0,4.606-1.514.231.231,0,0,1,.322-.037l.018.016a4.412,4.412,0,0,0,3.049,1.1.228.228,0,0,1,.218.224V30.9a1.763,1.763,0,0,1,1.5.475V28.188a2.429,2.429,0,0,0-2.424-2.424,2.394,2.394,0,0,0-1.237.345,2.426,2.426,0,0,0-2.079-1.186H51.234A4.394,4.394,0,0,0,46.853,29.3v1.963a1.767,1.767,0,0,1,1.105-.389",
    transform: "translate(35.615 18.945)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240052",
    "data-name": "Path 240052",
    d: "M50.8,58.75v-8.9a1.75,1.75,0,0,1,3.5,0v8.9h3.953V43.636H46.848V58.75Z",
    transform: "translate(35.611 33.169)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240053",
    "data-name": "Path 240053",
    d: "M64.97,42.7l-2.146-7.553a2.3,2.3,0,0,0-1.515-1.313l-4.138-.671-.637,1.148a1.017,1.017,0,0,1-.887.523H53.6a1.018,1.018,0,0,1-.889-.523l-.637-1.148-4.136.671a2.3,2.3,0,0,0-1.515,1.313L44.28,42.7a2.162,2.162,0,0,0,.669,2.566l3.564,2.32v3.5a.519.519,0,0,0,.519.519H60.218a.519.519,0,0,0,.519-.519v-3.5l3.564-2.32A2.162,2.162,0,0,0,64.97,42.7",
    transform: "translate(33.526 25.206)",
    fill: "#e5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240054",
    "data-name": "Path 240054",
    d: "M52.734,28.306a1.694,1.694,0,0,0-.283.023c.007.1.011.19.011.287v2.924c0,.1,0,.19-.011.285a1.771,1.771,0,1,0,.569-3.5A1.731,1.731,0,0,0,52.734,28.306Z",
    transform: "translate(39.87 21.517)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240055",
    "data-name": "Path 240055",
    d: "M48.524,31.54V28.617c0-.1,0-.192.011-.287a1.773,1.773,0,1,0-.59,3.5,1.745,1.745,0,0,0,.59,0c-.007-.1-.011-.188-.011-.285",
    transform: "translate(35.321 21.516)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240056",
    "data-name": "Path 240056",
    d: "M52.514,27.257a4.6,4.6,0,0,1-4.606,1.514.227.227,0,0,0-.269.174l0,.044v3.416a4.244,4.244,0,0,0,8.487,0V28.559a.227.227,0,0,0-.22-.224,4.416,4.416,0,0,1-3.049-1.1.226.226,0,0,0-.322,0Z",
    transform: "translate(36.209 20.652)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240057",
    "data-name": "Path 240057",
    d: "M53.336,32.978v-.76A4.21,4.21,0,0,1,49,32.211v.8a1.124,1.124,0,0,1-.433.889l.625,1.125a1.014,1.014,0,0,0,.887.523h2.181a1.016,1.016,0,0,0,.887-.521l.639-1.151A1.127,1.127,0,0,1,53.336,32.978Z",
    transform: "translate(36.916 24.485)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240058",
    "data-name": "Path 240058",
    d: "M53.951,42.315l-.977-1.561H50.517v.239a1.652,1.652,0,0,0,1.646,1.647H53.84a1.723,1.723,0,0,0,.424-.058.673.673,0,0,1-.313-.268",
    transform: "translate(38.4 30.979)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240059",
    "data-name": "Path 240059",
    d: "M47.83,42.315l.977-1.561h2.457v.239a1.652,1.652,0,0,1-1.646,1.647H47.941a1.735,1.735,0,0,1-.424-.058.673.673,0,0,0,.313-.268",
    transform: "translate(36.12 30.979)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240060",
    "data-name": "Path 240060",
    d: "M49.218,43.485a.692.692,0,0,1,.13.887l-.364.579h6.447l-.364-.579a.692.692,0,0,1,.13-.887l1.809-1.3V35.869a.638.638,0,0,0-.637-.637H47.922a.637.637,0,0,0-.637.637v6.224Z",
    transform: "translate(35.943 26.781)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240061",
    "data-name": "Path 240061",
    d: "M44.955,33.95a1,1,0,0,1-1.222-.7v0L42.5,28.634a1,1,0,1,1,1.927-.516l1.236,4.61a1,1,0,0,1-.7,1.222h0",
    transform: "translate(32.278 20.812)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240062",
    "data-name": "Path 240062",
    d: "M44.907,33.768a.981.981,0,1,1,.014,0l-.016,0Z",
    transform: "translate(33.181 24.177)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240063",
    "data-name": "Path 240063",
    d: "M47.913,25.289a2.21,2.21,0,0,1-1.753-1.753.04.04,0,0,0-.048-.03.043.043,0,0,0-.03.03,2.206,2.206,0,0,1-1.751,1.753.039.039,0,0,0-.03.048.038.038,0,0,0,.03.03,2.206,2.206,0,0,1,1.751,1.753.04.04,0,0,0,.077,0,2.21,2.21,0,0,1,1.753-1.753.04.04,0,0,0,.03-.048.043.043,0,0,0-.03-.03",
    transform: "translate(33.675 17.868)",
    fill: "#fefcfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240064",
    "data-name": "Path 240064",
    d: "M44.665,45.453H42.933a.5.5,0,1,1,0-1h1.732a.5.5,0,0,1,0,1",
    transform: "translate(32.255 33.794)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240065",
    "data-name": "Path 240065",
    d: "M43.424,46.694a.5.5,0,0,1-.5-.5V44.462a.5.5,0,1,1,1,0V46.2a.5.5,0,0,1-.5.5",
    transform: "translate(32.63 33.419)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240066",
    "data-name": "Path 240066",
    d: "M39.862,47.068a.506.506,0,0,1-.354-.146.525.525,0,0,1-.062-.076.5.5,0,0,1-.046-.086.571.571,0,0,1-.028-.093.6.6,0,0,1-.009-.1.622.622,0,0,1,.009-.1.551.551,0,0,1,.028-.092.521.521,0,0,1,.046-.088.642.642,0,0,1,.062-.076.506.506,0,0,1,.544-.107.58.58,0,0,1,.086.046.478.478,0,0,1,.137.137.522.522,0,0,1,.046.088.557.557,0,0,1,.03.092.621.621,0,0,1,.009.1.6.6,0,0,1-.009.1.576.576,0,0,1-.03.093.5.5,0,0,1-.046.086.428.428,0,0,1-.062.076.414.414,0,0,1-.076.062.452.452,0,0,1-.086.046.356.356,0,0,1-.093.028.452.452,0,0,1-.1.011",
    transform: "translate(29.922 35.021)",
    fill: "#fd9512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240067",
    "data-name": "Path 240067",
    d: "M40.671,33.212a.506.506,0,0,1-.354-.146.525.525,0,0,1-.062-.076.5.5,0,0,1-.046-.086.57.57,0,0,1-.028-.093.6.6,0,0,1-.009-.1.621.621,0,0,1,.009-.1.55.55,0,0,1,.028-.092.521.521,0,0,1,.046-.088.642.642,0,0,1,.062-.076.506.506,0,0,1,.544-.107.58.58,0,0,1,.086.046.478.478,0,0,1,.137.137.521.521,0,0,1,.046.088.557.557,0,0,1,.03.092.622.622,0,0,1,.009.1.6.6,0,0,1-.009.1.577.577,0,0,1-.03.093.5.5,0,0,1-.046.086.429.429,0,0,1-.062.076.415.415,0,0,1-.076.062.453.453,0,0,1-.086.046.355.355,0,0,1-.093.028.453.453,0,0,1-.1.011",
    transform: "translate(30.537 24.489)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240068",
    "data-name": "Path 240068",
    d: "M44.912,34.7a1.5,1.5,0,0,1-1.443-1.109l-1.237-4.61a1.5,1.5,0,0,1,2.89-.774l1.234,4.61A1.5,1.5,0,0,1,45.3,34.646,1.519,1.519,0,0,1,44.912,34.7Zm-1.236-6.6a.5.5,0,0,0-.5.5.524.524,0,0,0,.016.128l1.236,4.61a.5.5,0,1,0,.963-.259l-1.236-4.61a.5.5,0,0,0-.481-.37",
    transform: "translate(32.063 20.596)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240069",
    "data-name": "Path 240069",
    d: "M44.864,34.518a1.494,1.494,0,1,1,.389-.051,1.532,1.532,0,0,1-.389.051m0-1.994a.5.5,0,1,0,.5.5.538.538,0,0,0-.016-.13A.5.5,0,0,0,44.866,32.524Z",
    transform: "translate(32.964 23.961)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240070",
    "data-name": "Path 240070",
    d: "M31.753,48.153H29.767a.5.5,0,0,1-.5-.5V35.577a.5.5,0,0,1,.5-.5h1.985a.93.93,0,0,1,.929.929V47.224A.928.928,0,0,1,31.753,48.153Zm-1.487-1h1.42V36.077h-1.42Z",
    transform: "translate(22.249 26.665)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240071",
    "data-name": "Path 240071",
    d: "M38.388,36.691h-1.45a.5.5,0,0,1,0-1h1.45a.5.5,0,0,1,0,1",
    transform: "translate(27.7 27.133)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240072",
    "data-name": "Path 240072",
    d: "M40.26,38.21h-1.6a.5.5,0,1,1,0-1h1.6a.5.5,0,0,1,0,1",
    transform: "translate(29.005 28.288)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240073",
    "data-name": "Path 240073",
    d: "M40.26,39.729h-1.6a.5.5,0,1,1,0-1h1.6a.5.5,0,0,1,0,1",
    transform: "translate(29.005 29.443)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240074",
    "data-name": "Path 240074",
    d: "M40.26,41.247h-1.6a.5.5,0,1,1,0-1h1.6a.5.5,0,0,1,0,1",
    transform: "translate(29.005 30.596)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240075",
    "data-name": "Path 240075",
    d: "M30.441,49.565H28.631a1.29,1.29,0,0,1-1.29-1.29l0-12.383a1.29,1.29,0,0,1,1.29-1.29h1.808a1.29,1.29,0,0,1,1.29,1.29V48.275a1.29,1.29,0,0,1-1.29,1.29M28.633,35.6a.294.294,0,0,0-.294.294l0,12.383a.294.294,0,0,0,.294.294h1.809a.294.294,0,0,0,.294-.294V35.892a.294.294,0,0,0-.294-.294Z",
    transform: "translate(20.783 26.302)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240076",
    "data-name": "Path 240076",
    d: "M45.973,48.671H39.145a6.231,6.231,0,0,1-1.9-.3c-.188-.053-.375-.116-.572-.183a6.4,6.4,0,0,0-2.237-.431H31.14a.5.5,0,0,1-.5-.5V37.524a.5.5,0,0,1,.491-.5L32.826,37a5.055,5.055,0,0,0,3.179-1.2,8.235,8.235,0,0,1,.73-.5A7.314,7.314,0,0,1,40.9,34h1.857a1.99,1.99,0,0,1,1.723,2.98l6.99.005a1.832,1.832,0,0,1,0,3.663H47.6a1.833,1.833,0,0,1-.375,2.176,1.832,1.832,0,0,1,.083,2.589c-.026.03-.055.056-.083.084a1.833,1.833,0,0,1-1.257,3.17Zm-14.335-1.91h2.8a7.361,7.361,0,0,1,2.559.484c.187.063.363.123.525.169l.021.005a5.19,5.19,0,0,0,1.607.253h6.828a.838.838,0,0,0,0-1.676.5.5,0,1,1,0-1,.838.838,0,0,0,0-1.676.5.5,0,1,1,0-1,.839.839,0,0,0,0-1.677.5.5,0,1,1,0-1h5.5a.834.834,0,0,0,0-1.669l-8.711-.009a.5.5,0,1,1,0-1,.991.991,0,0,0,0-1.982H40.9a6.313,6.313,0,0,0-3.614,1.132l-.035.023a6.968,6.968,0,0,0-.657.449A6.055,6.055,0,0,1,32.853,38l-1.216.018Z",
    transform: "translate(23.292 25.846)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240077",
    "data-name": "Path 240077",
    d: "M43.676,35.842a.5.5,0,0,1-.329-.123l-1.86-1.633a.5.5,0,1,1,.658-.75l1.86,1.633a.5.5,0,0,1-.329.873Z",
    transform: "translate(31.406 25.245)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240078",
    "data-name": "Path 240078",
    d: "M42.139,41.24a.5.5,0,0,1-.352-.852L43.079,39.1a.5.5,0,0,1,.7.706L42.491,41.1A.5.5,0,0,1,42.139,41.24Z",
    transform: "translate(31.653 29.618)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240079",
    "data-name": "Path 240079",
    d: "M52.949,32.564a2.271,2.271,0,0,1-.361-.032.5.5,0,0,1-.419-.525c.005-.084.009-.167.009-.252V28.831c0-.084,0-.169-.009-.253a.5.5,0,0,1,.419-.525,2.27,2.27,0,1,1,.361,4.511Zm.227-3.524v2.506a1.274,1.274,0,0,0,0-2.506",
    transform: "translate(39.655 21.302)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240080",
    "data-name": "Path 240080",
    d: "M48.46,32.564a2.271,2.271,0,0,1,0-4.541,2.23,2.23,0,0,1,.359.03.5.5,0,0,1,.419.526c-.005.083-.009.167-.009.252v2.925c0,.083,0,.167.009.25a.5.5,0,0,1-.419.526,2.5,2.5,0,0,1-.363.032m-.225-3.524a1.274,1.274,0,0,0,0,2.506Z",
    transform: "translate(35.112 21.301)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240081",
    "data-name": "Path 240081",
    d: "M52.095,37.363a4.746,4.746,0,0,1-4.742-4.744V29.206a.716.716,0,0,1,.266-.561.727.727,0,0,1,.607-.148,4.073,4.073,0,0,0,4.113-1.336.731.731,0,0,1,.525-.275.744.744,0,0,1,.554.208,3.955,3.955,0,0,0,2.714.958.725.725,0,0,1,.7.711v3.856a4.747,4.747,0,0,1-4.74,4.744M48.349,29.53v3.089a3.745,3.745,0,0,0,7.489.055V29.036A4.969,4.969,0,0,1,52.936,28a5.072,5.072,0,0,1-4.587,1.531",
    transform: "translate(35.995 20.437)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240082",
    "data-name": "Path 240082",
    d: "M58.435,32.087a.5.5,0,0,1-.347-.139,1.258,1.258,0,0,0-1.079-.341.5.5,0,0,1-.569-.415.571.571,0,0,1-.005-.077v-.371a4.97,4.97,0,0,1-2.9-1.037,5.074,5.074,0,0,1-4.6,1.528.5.5,0,0,1-.561.373,1.232,1.232,0,0,0-.989.262.5.5,0,0,1-.81-.389V29.519a4.886,4.886,0,0,1,4.879-4.879h1.244a2.93,2.93,0,0,1,2.237,1.051,2.913,2.913,0,0,1,4,2.712v3.186A.5.5,0,0,1,58.435,32.087Zm-1-1.482a2.313,2.313,0,0,1,.5.109V28.4a1.917,1.917,0,0,0-2.906-1.651.5.5,0,0,1-.685-.171,1.94,1.94,0,0,0-1.651-.945H51.449a3.888,3.888,0,0,0-3.883,3.883v1.158a2.322,2.322,0,0,1,.451-.077.728.728,0,0,1,.8-.4,4.077,4.077,0,0,0,4.113-1.336.731.731,0,0,1,.525-.275.741.741,0,0,1,.553.206,3.955,3.955,0,0,0,2.716.959.724.724,0,0,1,.7.711Z",
    transform: "translate(35.4 18.73)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240083",
    "data-name": "Path 240083",
    d: "M52.472,36.265H50.293a1.513,1.513,0,0,1-1.324-.778l-.625-1.126a.5.5,0,0,1,.127-.634.631.631,0,0,0,.243-.5v-.8A.5.5,0,0,1,49.469,32a3.718,3.718,0,0,0,3.827.009.5.5,0,0,1,.683.172.481.481,0,0,1,.07.255v.757a.629.629,0,0,0,.252.5.5.5,0,0,1,.134.637L53.8,35.483a1.515,1.515,0,0,1-1.324.781M49.393,34.2l.447.8a.523.523,0,0,0,.452.268h2.179A.52.52,0,0,0,52.924,35l.458-.826a1.618,1.618,0,0,1-.329-.95,4.771,4.771,0,0,1-3.343-.005v.009A1.605,1.605,0,0,1,49.393,34.2Z",
    transform: "translate(36.701 24.27)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240084",
    "data-name": "Path 240084",
    d: "M53.893,45.033a1.192,1.192,0,0,1-1.009-.558l-1.339-2.14a1.188,1.188,0,0,1,.222-1.526l.039-.03,3.364-2.425a.5.5,0,0,1,.584.81l-3.341,2.406a.194.194,0,0,0-.023.236l1.341,2.14a.192.192,0,0,0,.266.062L54.009,44l.908-.69a.5.5,0,0,1,.614.785l-.012.009-.906.688A1.18,1.18,0,0,1,53.893,45.033Z",
    transform: "translate(39.043 29.083)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240085",
    "data-name": "Path 240085",
    d: "M60.431,52.312H49.246A1.016,1.016,0,0,1,48.23,51.3V48.069l-3.337-2.174-.033-.023a2.656,2.656,0,0,1-.834-3.128l2.139-7.521a.34.34,0,0,1,.019-.06,2.78,2.78,0,0,1,1.845-1.6.223.223,0,0,1,.049-.011l4.138-.671a.491.491,0,0,1,.514.25l.639,1.148a.517.517,0,0,0,.451.266H55.86a.516.516,0,0,0,.452-.266l.639-1.148a.494.494,0,0,1,.514-.25l4.138.671a.223.223,0,0,1,.049.011,2.78,2.78,0,0,1,1.845,1.6l.023.06,2.135,7.523a2.657,2.657,0,0,1-.834,3.128l-.03.021-3.337,2.174V51.3A1.022,1.022,0,0,1,60.431,52.312ZM45.454,45.071,49,47.381a.5.5,0,0,1,.225.417v3.5a.021.021,0,0,0,.019.021H60.431a.023.023,0,0,0,.023-.021V47.8a.5.5,0,0,1,.225-.417l3.548-2.309a1.664,1.664,0,0,0,.5-1.964.34.34,0,0,1-.019-.06l-2.139-7.519a1.789,1.789,0,0,0-1.149-.994l-3.765-.611-.47.841a1.511,1.511,0,0,1-1.324.78H53.819a1.512,1.512,0,0,1-1.322-.78l-.47-.841-3.763.611a1.8,1.8,0,0,0-1.153.994l-2.137,7.519a.6.6,0,0,1-.019.06A1.658,1.658,0,0,0,45.454,45.071Z",
    transform: "translate(33.31 24.991)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240086",
    "data-name": "Path 240086",
    d: "M54.055,43.353H52.378a2.147,2.147,0,0,1-2.144-2.146v-.239a.5.5,0,0,1,.5-.5h2.457a.5.5,0,0,1,.422.234l.977,1.561a.187.187,0,0,0,.088.072.5.5,0,0,1-.069.94A2.083,2.083,0,0,1,54.055,43.353Zm-2.8-1.885a1.152,1.152,0,0,0,1.118.889h1.091l-.556-.889Z",
    transform: "translate(38.185 30.763)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240087",
    "data-name": "Path 240087",
    d: "M55.646,45.665H49.2a.5.5,0,0,1-.422-.762l.364-.581a.194.194,0,0,0-.025-.236l-1.908-1.375a.5.5,0,0,1-.206-.4V36.084a1.136,1.136,0,0,1,1.135-1.135h8.447a1.137,1.137,0,0,1,1.135,1.135V42.4a.5.5,0,0,1-.208.4l-1.783,1.285a.192.192,0,0,0-.025.236l.364.581a.5.5,0,0,1-.422.762Zm-5.567-1h4.685a1.187,1.187,0,0,1,.317-1.343l.039-.03,1.6-1.155V36.084a.14.14,0,0,0-.139-.139H48.137a.14.14,0,0,0-.139.139v5.969L49.725,43.3l.037.03A1.184,1.184,0,0,1,50.079,44.668Z",
    transform: "translate(35.728 26.566)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240088",
    "data-name": "Path 240088",
    d: "M48.255,45.033a1.184,1.184,0,0,1-.72-.243l-.908-.688a.5.5,0,0,1,.6-.794l.908.688a.191.191,0,0,0,.28-.051l1.341-2.14a.191.191,0,0,0-.025-.236l-3.339-2.406a.5.5,0,0,1,.584-.81l3.364,2.425a.3.3,0,0,1,.037.03,1.184,1.184,0,0,1,.224,1.524l-1.341,2.142A1.187,1.187,0,0,1,48.255,45.033Z",
    transform: "translate(35.109 29.083)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240089",
    "data-name": "Path 240089",
    d: "M49.834,43.352H48.156a2.091,2.091,0,0,1-.553-.074.5.5,0,0,1-.069-.94.187.187,0,0,0,.088-.072l.977-1.561a.5.5,0,0,1,.422-.234h2.457a.5.5,0,0,1,.5.5v.239A2.148,2.148,0,0,1,49.834,43.352Zm-1.091-1h1.091a1.148,1.148,0,0,0,1.118-.889H49.3Z",
    transform: "translate(35.905 30.764)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240090",
    "data-name": "Path 240090",
    d: "M58.47,59.464H54.515a.5.5,0,0,1-.5-.5v-8.9a1.251,1.251,0,0,0-2.5,0v8.9a.5.5,0,0,1-.5.5H47.062a.5.5,0,0,1-.5-.5V43.851a.5.5,0,0,1,.5-.5H58.468a.5.5,0,0,1,.5.5V58.965a.5.5,0,0,1-.5.5m-3.455-1h2.957V44.349H47.562V58.467h2.957v-8.4a2.248,2.248,0,0,1,4.5,0Z",
    transform: "translate(35.395 32.954)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg43Covered);
export default __webpack_public_path__ + "static/media/4.3_Covered.8a7d5f7f0b67e95a1cdf4bdb42e0189c.svg";
export { ForwardRef as ReactComponent };